export const data = [
    {
        title: 'Marketing Trainee',
        desc: 'UniferX International GmbH is a young international technology company with HQ in Germany and a great team in various countries of Central/Eastern Europe, developing solutions for agriculture that shall respond...',
        labels: [{ type: 'place', text: 'Kyiv/Ukraine or Chisinau/Moldova' }],
        date: '29.08.2023',
    },
    {
        title: 'Junior Marketing Manager',
        desc: 'UniferX International GmbH is a young international technology company with HQ in Germany and a great team in various countries of Central/Eastern Europe, developing solutions for agriculture that shall respond...',
        labels: [{ type: 'place', text: 'Kyiv/Ukraine or Chisinau/Moldova' }],
        date: '28.08.2023',
    },
    {
        title: 'Chief accountant',
        desc: 'We are an international company that develops and implements innovative technologies in agriculture. The headquarters is located in Germany, and we also work in several European countries...',
        labels: [
            { type: 'place', text: 'Ukraine, Kyiv' },
            { type: 'office', text: 'Office only' },
            { type: 'experience', text: '3 years of experience' },
        ],
        date: '02.08.2023',
    },
    {
        title: 'Agronomist researcher',
        desc: 'UniferX International GmbH is a young international technology company with HQ in Germany and a great team in various countries of Central/Eastern Europe, developing solutions...',
        labels: [
            { type: 'place', text: 'Central/Eastern Europe' },
            { type: 'experience', text: '3 years of experience' },
        ],
        date: '25.08.2023',
    },
];

export const labels = [
    { type: 'place', text: 'Ukraine, Kyiv' },
    { type: 'office', text: 'Office only' },
    { type: 'experience', text: '3 years of experience' },
];
